import React from 'react'
import AOSInit from '../../components/Animation/AOSInit'
import NavBarHome from '../../components/NavBar/NavBarHome'
import Footer from '../../components/Footer/Footer'
import MethodologySection from './MethodologySection'

function NextMakerMethod() {
   return (
      <div className="pt-[92px] flex flex-col min-h-screen overflow-x-hidden">
         <AOSInit />
         <NavBarHome />

         <MethodologySection />

         {/* Footer */}
         <section id="footer">
            <Footer
               logo={"/Logo NextMaker.png"}
               bgColor="bg-[#140342]"
               textColor="text-white"
               borderColor="border-gray-400/20"
            />
         </section>
      </div>
   )
}

export default NextMakerMethod